//@flow

import React from "react";

type Props = {
    logo: string,
    name: string,
    link?: Link,
};

const PartnerView = (props: Props): React$Element<"a"> | React$Element<"div"> => {
    const logoAlt = `${props.name} logo`;

    const view = (
        <div className="partner-view mt-4 mt-md-5">
            <div className="logo">
                <img src={props.logo} alt={logoAlt} />
            </div>
            <div className="name mt-1 mt-md-2 fs-3">{props.name}</div>
        </div>
    );

    if (props.link) {
        return (
            <a href={props.link.path} target={props.link.target}>
                {view}
            </a>
        );
    }

    return view;
};

export default PartnerView;
